import { useState, useEffect } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Label } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'


export function SelectBox({ className, level = 1, ...props }) {
    const keyName = ((props?.keyid) ? props?.keyid : 'key');
    const {data} = props;
    const {label, placeHolder, boxfield, boxfieldSub} = props;
    let {disabled} = props;
    if(!disabled) {
        disabled = false;
    }
    
    
    const getSubField = ((item) => {
       if((typeof boxfieldSub) == 'string') {
           let boxfields = boxfieldSub.split("|");
           for(let i in boxfields) {
               let subFields = boxfields[i].split(".");
               let val = null;
               for(let j in subFields) {
                   if(!val) {
                    val = item[subFields[j]];
                   } else {
                       val = val[subFields[j]];
                   }

               }
               if((typeof val) == 'string' && val != "") {
                    return val;                   
               }
           }
           
       }     
        
    });
     const [query, setQuery] = useState('')
     let initSelect = null
     
    if(props?.selected && props?.selected != null && (typeof(props.selected) == 'string' || typeof(props.selected) == 'object') ) {
        let selectedKey = null;
        if(typeof(props.selected) == 'object') {
            selectedKey = props.selected[keyName];
        } else {
            selectedKey = props.selected;
        }
        for(let i in data) {
            if(data[i] && data[i][keyName] == selectedKey) {
                initSelect = data[i];
                break;
            }
        }
    } else if(props?.emptyOption && !props?.selected) {
        initSelect = props?.emptyOption;
    }else if(props?.selected) {
        initSelect = ((!props.selected) ? "" : props.selected);
    }     
  const [selectedItem, setSelectedItem] = useState();
    const changeEventHandler= (selectedItem) => {
        const {changeEvent} = props;
        setSelectedItem(selectedItem);
        if(changeEvent) {
            changeEvent(props.name, selectedItem);
        }         
        setQuery('')
    }

   useEffect(() => {
        if(initSelect) {
        setSelectedItem(initSelect);
        }
        }, [initSelect,setSelectedItem]);


  const filteredData =
    query === ''
      ? data
      : data.filter((item) => {
        let retVal = item[boxfield];
        if(retVal) {
            retVal = retVal.toLowerCase().includes(query.toLowerCase())
        }
          return retVal; 
        })
        
  return (

                <Combobox disabled={disabled}  
                key={((selectedItem) ? selectedItem.id: 'onbekend')}
      as="div"
        value={selectedItem}
      onChange={(item) => {
          changeEventHandler(item);
      }}
    >
      <Label className="block text-sm font-medium leading-6 text-gray-900">{label}</Label>
      <div className="relative">
        <ComboboxInput
        key={((selectedItem) ? selectedItem.id: 'onbekend')}
          className="w-full rounded-md border-0 bg-white py-.5 pl-3 pr-12 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          onChange={(event) => setQuery(event.target.value)}
          onBlur={() => setQuery('')}
          displayValue={(selectedItem) => (selectedItem) ? selectedItem[boxfield] : "ad"}
          placeholder={placeHolder} immediate
        />
        {!disabled &&        
        <ComboboxButton className="absolute z-2 inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
          <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </ComboboxButton>
        }   
        {filteredData && filteredData.length >= 0 && (
          <ComboboxOptions className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {props.canAdd &&
            <ComboboxOption value={{ id: null, name: query }} className="data-[focus]:bg-blue-100">
            Create <span className="font-bold">"{query}"</span>
          </ComboboxOption>
          }
          {props.emptyOption && 
              <ComboboxOption
                key={props?.emptyOption?.name}
                value={props?.emptyOption}
                className="group relative z-50 cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
              >
                <div className="flex">
                  <span className="truncate group-data-[selected]:font-semibold">{props?.emptyOption?.name}</span>
                </div>
                 
                <span className="absolute inset-y-0 right-0 hidden items-center pr-4 text-indigo-600 group-data-[selected]:flex group-data-[focus]:text-white">
                  <CheckIcon className="h-5 w-5" aria-hidden="true" />
                </span>
              </ComboboxOption>
          
          }
          
            {filteredData.map((item) => (
              <ComboboxOption
                key={item.name}
                value={item}
                className="group relative z-50 cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
              >
                <div className="flex">
                  <span className="truncate group-data-[selected]:font-semibold">{item[boxfield]}</span>
                  <span className="ml-2 truncate text-gray-500 group-data-[focus]:text-indigo-200">
                    {getSubField(item)}
                  </span>
                  
                   {item.extraVeld &&
                  <span className="ml-2 truncate text-gray-500 group-data-[focus]:text-indigo-200">
                    {item.name}
                  </span>
                  }
                </div>
                 
                <span className="absolute inset-y-0 right-0 hidden items-center pr-4 text-indigo-600 group-data-[selected]:flex group-data-[focus]:text-white">
                  <CheckIcon className="h-5 w-5" aria-hidden="true" />
                </span>
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        )}
      </div>
    </Combobox>

  )
}
